import { createSelector } from '@reduxjs/toolkit'
import { RootState } from 'domains/store'

export const selectError = createSelector(
  ({ interrupt }: RootState) => interrupt,
  ({ error }: RootState['interrupt']) => error,
)

export const selectHasError = createSelector(selectError, (error) =>
  Boolean(error),
)
